const parseCelsiusToFahrenheit = (celsius: number, parseExactChange: boolean = false): number => {
  return celsius * 1.8 + (parseExactChange ? 0 : 32)
}

export default parseCelsiusToFahrenheit
